import { atom } from "recoil";

import { IEtlSchedulesSchemas } from "../../models";

export const etlSchemasAtom = atom<IEtlSchedulesSchemas | undefined>({
  key: "etlSchemasAtom",
  default: undefined,
});
